import React from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Stack from 'react-bootstrap/Stack';
import { LinkContainer } from "react-router-bootstrap";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { DataContext } from './DataContextProvider.js';
import FiltersModal from './FiltersModal.js';
import moment from 'moment';

export default function Header({ title, location, skipPageTitle, children }) {
  const [showFiltersModal, setShowFiltersModal] = React.useState(false);
  const dataContext = React.useContext(DataContext);

  if (!skipPageTitle) {
    document.title = title + ' - Twilio Blogalytics';
  }

  const changeDates = (ev, picker) => {
    dataContext.setRange(picker.startDate.toDate(), picker.endDate.toDate());
  };

  const onKeyDown = (ev) => { if (ev.keyCode === 13) { ev.preventDefault(); } }

  const openFiltersModal = () => { setShowFiltersModal(true); };
  const closeFiltersModal = () => { setShowFiltersModal(false); };
  const haveFilters = Object.keys(dataContext.globalFilters).length > 0 || dataContext.pubStart !== null;

  const selectTwilio = () => {
    dataContext.setBlog('twilio');
    dataContext.forceUpdate();
  };
  const selectSendGrid= () => {
    dataContext.setBlog('sendgrid');
    dataContext.forceUpdate();
  };
  const selectAll = () => {
    dataContext.setBlog('all');
    dataContext.forceUpdate();
  };
  const selectDocs = () => {
    dataContext.setBlog('docs');
    dataContext.forceUpdate();
  };

  return (
    <>
      <Navbar bg="light" expand="lg">
        <Container fluid>
          <Stack direction="horizontal">
            <LinkContainer to={location}>
              <Navbar.Brand>{title}</Navbar.Brand>
            </LinkContainer>
            <Form>
              <Stack direction="horizontal" gap={2}>
                  {children !== undefined &&
                    <>
                      {children} 
                      <Nav.Item>&nbsp;</Nav.Item>
                    </>
                  }
                  <Dropdown>
                    <Dropdown.Toggle variant="light" id="dropdown-basic">
                      {(dataContext.blog === 'twilio' || dataContext.blog === 'all') &&
                        <><img src="/twilio.png" width="16" alt="Twilio Blog" />&nbsp;</>
                      }
                      {(dataContext.blog === 'sendgrid' || dataContext.blog === 'all') &&
                        <><img src="/sendgrid.png" width="16" alt="SendGrid Blog" />&nbsp;</>
                      }
                      {(dataContext.blog === 'docs') &&
                        <><img src="/twilio-black.png" width="16" alt="Docs" />&nbsp;</>
                      }
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={selectTwilio}><img alt="" src="/twilio.png" width="16" /> Twilio Blog</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <Button variant={!haveFilters ? 'outline-secondary' : 'secondary'} onClick={openFiltersModal}>
                    {!haveFilters ? 'Add' : 'Edit'}&nbsp;Filters
                  </Button>
                  <DateRangePicker initialSettings={{
                    startDate: dataContext.start,
                    endDate: dataContext.end,
                    showDropdowns: true,
                    ranges: {
                      'Last 7 Days': [moment.utc().subtract(7, 'days'), moment.utc().subtract(1, 'days')],
                      'Last 30 Days': [moment.utc().subtract(30, 'days'), moment.utc().subtract(1, 'days')],
                      'This Month': [moment.utc().startOf('month'), moment.utc().subtract(1, 'days')],
                      'Last Month': [moment.utc().subtract(1, 'month').startOf('month'), moment.utc().subtract(1, 'month').endOf('month')],
                      'This Quarter': [moment.utc().startOf('quarter'), moment.utc().subtract(1, 'days')],
                      'Last Quarter': [moment.utc().subtract(1, 'quarter').startOf('quarter'), moment.utc().subtract(1, 'quarter').endOf('quarter')],
                      'This Year': [moment.utc().startOf('year'), moment.utc().subtract(1, 'days')],
                      'Last Year': [moment.utc().subtract(1, 'year').startOf('year'), moment.utc().subtract(1, 'year').endOf('year')],
                    },
                  }} onApply={changeDates} onHide={changeDates}>
                    <input type="text" className="form-control date-range" onKeyDown={onKeyDown} />
                  </DateRangePicker>
              </Stack>
            </Form>
          </Stack>
        </Container>
      </Navbar>
      <FiltersModal show={showFiltersModal} close={closeFiltersModal} />
    </>
  )
}
